import React, { Component, Suspense } from "react";
import { Route, Switch } from "react-router";

import { SiteRutas } from "./request/RutasConfig";

const Layout = React.lazy(() => import("./containers/Layout"));  
const LoginPage = React.lazy(() => import("./containers/Login/LoginPage"));
const CambiarContrasenaPage = React.lazy(() => import("./containers/CambiarContrasena/CambiarContrasenaPage"));
const CambiarPinPage = React.lazy(() => import("./containers/CambiarPin/CambiarPinPage"));
const HomePage = React.lazy(() => import("./containers/HomePage"));
const LiquidarOrden = React.lazy(() => import("./containers/liquidacionOrdenes/LiquidarOrden.jsx"));
const ParametersPage = React.lazy(() => import("./containers/Parametros/ParametrosPage"));
const CallCenter_OrderDetailsPage = React.lazy(() => import("./containers/MonitorCallCenter/DetallesOrdenPage"));
const CallCenter_OrdersPage = React.lazy(() => import("./containers/MonitorCallCenter/OrdenesPage"));
const CallCenter = React.lazy(() => import("./containers/CallCenter/CallCenter.jsx"));
const CallCenterMantenimiento = React.lazy(() => import("./containers/CallCenter/Interfaz/CallCenterMantenimiento.jsx"));
const Zonas = React.lazy(() => import("./containers/zonas/index.jsx"));
const zonasMantenimiento = React.lazy(() => import("./containers/zonas/Interfaz/zonasMantenimiento.jsx"));
const MonitorSucursales = React.lazy(() => import("./containers/monitorSucursal/MonitorSucursales.jsx"));
const Color = React.lazy(() => import("./containers/colores/index.jsx"));
const Repartidor = React.lazy(() => import("./containers/repartidores/index.jsx"));
const RepartidorMantenimiento = React.lazy(() => import("./containers/repartidores/Interfaz/repartidorMantenimiento.jsx"));
const Tiempo = React.lazy(() => import("./containers/tiempos/index.jsx"));
const Reporte = React.lazy(() => import("./containers/reporte/index.jsx"));
const ConsultaRepartidores = React.lazy(() => import("./containers/ConsultaRepartidores/ConsultaRepartidores.jsx"));
const Picking = React.lazy(() => import("./containers/Picking/Picking.jsx"));

export default class App extends Component {
    render() {

        return (
            <Suspense fallback={null}>
                <Switch>
                    <Route
                        path={[
                            SiteRutas.Home,
                            SiteRutas.Parametros,
                            SiteRutas.MonitorCallCenter,
                            SiteRutas.MonitorCallCenterDetalle,
                            SiteRutas.CallCenter,
                            `${SiteRutas.CallCenterMantenimiento}/:id`,
                            SiteRutas.Zonas,
                            `${SiteRutas.ZonasMantenimiento}/:id/:CC_id`,
                            SiteRutas.LiquidarOrden,
                            SiteRutas.MonitorSucursales,
                            SiteRutas.Color,
                            `${SiteRutas.ColorMantenimiento}/:id`,
                            SiteRutas.Repartidor,
                            `${SiteRutas.RepartidorMantenimiento}/:id/:CC_id`,
                            SiteRutas.Tiempos,
                            `${SiteRutas.Reporte}/:ReportId/:Sec`,
                            SiteRutas.ConsultaRepartidores,
                            SiteRutas.Picking,
                        ]}
                    >
                        <Layout>
                            <Switch>
                                <Route path={SiteRutas.Home} component={HomePage} />
                                <Route path={SiteRutas.Parametros} component={ParametersPage} />
                                <Route path={SiteRutas.MonitorCallCenter} component={CallCenter_OrdersPage} />
                                <Route path={SiteRutas.MonitorCallCenterDetalle} component={CallCenter_OrderDetailsPage} />
                                <Route path={SiteRutas.MonitorSucursales} component={MonitorSucursales} />
                                <Route path={SiteRutas.LiquidarOrden}  component={LiquidarOrden}/>
                                <Route path={SiteRutas.CallCenter} component={CallCenter} />
                                <Route path={`${SiteRutas.CallCenterMantenimiento}/:id`} component={CallCenterMantenimiento} />
                                <Route path={SiteRutas.Zonas} component={Zonas} />
                                <Route path={`${SiteRutas.ZonasMantenimiento}/:id/:CC_id`} component={zonasMantenimiento} />
                                <Route path={SiteRutas.Color} component={Color} />
                                <Route path={SiteRutas.Repartidor} component={Repartidor} />
                                <Route path={`${SiteRutas.RepartidorMantenimiento}/:id/:CC_id`} component={RepartidorMantenimiento} />
                                <Route path={SiteRutas.Tiempos} component={Tiempo} />
                                <Route path={`${SiteRutas.Reporte}/:ReportId/:Sec`} component={Reporte} />
                                <Route path={SiteRutas.ConsultaRepartidores} component={ConsultaRepartidores} />
                                <Route path={SiteRutas.Picking} component={Picking} />
                                <Route component={HomePage} />
                            </Switch>
                        </Layout>
                    </Route>
                    <Route
                        path={[
                            SiteRutas.Login,
                            SiteRutas.Base,
                            SiteRutas.CambiarContrasena,
                            SiteRutas.CambiarPin,
                        ]}
                    >
                        <Switch>
                            <Route path={SiteRutas.Login} component={LoginPage} />
                            <Route
                                path={SiteRutas.CambiarContrasena}
                                component={CambiarContrasenaPage}
                            />
                            <Route
                                path={SiteRutas.CambiarPin}
                                component={CambiarPinPage}
                            />
                            <Route component={LoginPage} />
                        </Switch>
                    </Route>
                </Switch>
            </Suspense>
        );
    }
}
